import { ApiResponse, PaginatedApiRequest, PaginatedApiResponse } from './ServiceModels';

export enum TransactionType {
  BULK_NEW_CONNECTION = 'BULK_NEW_CONNECTION',
  BULK_SIM_SWAP = 'BULK_SIM_SWAP',
  NEW_CONNECTION = 'NEW_CONNECTION',
  SIM_SWAP = 'SIM_SWAP',
  SUSPEND = 'SUSPEND',
  RESTORE = 'RESTORE',
  TERMINATION = 'TERMINATION',
}

export interface TransactionsFilter {
  filter: string;
  type: TransactionType | '';
  status?: string;
}

export enum TransactionStatus {
  COMPLETED = 'COMPLETED',
  PROCESSING = 'PROCESSING',
  ERROR = 'ERROR',
}

export interface TransactionTypesResponse extends ApiResponse {
  transactionTypes: TransactionType[];
}

export interface TransactionsCountersResponse extends TransactionsCounters, ApiResponse {
  journey: TransactionType;
}

export interface TransactionsCounters {
  submitted: number;
  processing: number;
  completed: number;
  error: number;
}

export interface TransactionsListRequest extends PaginatedApiRequest {
  journey?: TransactionType;
  filter?: string;
  bulkId?: string;
  statusList?: string[];
}

/**
 * Transaction list object
 */
export interface TransactionList {
  actionId: string;
  status: TransactionStatus;
  userEmail: string;
  userFullName: string;
  serialNumber: string;
  eid: string;
  creationDate: string;
}

/**
 * Bulk Transaction list object
 */
export interface BulkTransactionList {
  bulkId: string;
  creationDate: string;
  totalConnections: string;
  completedConnections: string;
  failedConnections: string;
  processingConnections: string;
}

/**
 * API response of the GET /transactions/list
 */
export interface TransactionsListResponse extends PaginatedApiResponse {
  journey: TransactionType;
  transactions: TransactionList[];
  bulkTransactions: BulkTransactionList[];
}
